import { Component, ViewChild } from '@angular/core';
import { DayPilotGanttComponent, DayPilot } from 'daypilot-pro-angular';

@Component({
  selector: 'app-gantt-bc-service',
   templateUrl: './gantt-bc-service.component.html',
  //templateUrl: ' <daypilot-gantt #gantt1 [config]="config"></daypilot-gantt>',
  styleUrls: ['./gantt-bc-service.component.scss']
})
export class GanttBcServiceComponent {

  // @ViewChild('gantt1', {static: false})
  @ViewChild('gantt1')

  gantt1: DayPilotGanttComponent;

  config: any = {
    startDate: "2020-03-01",
    days: new DayPilot.Date("2020-03-01").daysInMonth(),
    cellWidthSpec: "Auto",
    tasks:
      //  [
      //   {start: "2020-03-05", end: "2020-03-07", id: 1, text: "Task 1", complete: 50}
      //  ]
      [
        {
          "id": "1", "text": "Centre Médico-Sociale", "start": null, "end": null, "complete": "0", "children":
            [
              { "id": "2", "text": "Rasolofondraibe Victor Thierry", "start": "2020-03-05T00:00:00", "end": "2020-03-10T00:00:00", "complete": "30" },
              { "id": "3", "text": "RAKOTONDRANAIVO Ronnah Ainatiana", "start": "2020-03-10T00:00:00", "end": "2020-03-15T00:00:00", "complete": "75" },
              { "id": "4", "text": "ANDRIAMANGA Zafy Cécilia ", "start": "2020-03-09T00:00:00", "end": "2020-03-09T00:00:00", "complete": "0", "type": "Milestone" }
            ]
        }
      ]

  };

}
